export {} from './declarations';

export {} from './models';

export {} from './utilities';

import {
  shortcuts,
  kpis,
  recentAssignments,
  mfaPrompt as mfaPromptFeature,
} from './features';
export const { reducer: shortcutsReducer, Component: ShortcutsWidget } =
  shortcuts;
export const { reducer: kpisReducer, Component: KpisWidget } = kpis;
export const {
  reducer: recentAssignmentsReducer,
  Component: RecentAssignmentsWidget,
} = recentAssignments;
export const mfaPrompt = { ...mfaPromptFeature }; // parcel bug https://github.com/parcel-bundler/parcel/issues/8748

export {} from './devHarness';
